import React, { useState } from 'react';
import TutorialVideo, { requestedAutoplay } from './TutorialVideo';
import { getTutorialVideos } from '@/lib/tutorialVideos';

/** The explainer video registered for a marketing page (`pages` in the manifest). */
export default function PageVideo({ page, next = null, playButton = true, signup = null, className = 'page-video' }) {
  const [video] = getTutorialVideos('pages', page);
  const [autoplay] = useState(requestedAutoplay);
  if (!video) return null;
  return (
    <section className={className} aria-label={video.title}>
      <TutorialVideo video={video} priority variant="hero" autoplay={autoplay} next={next} playButton={playButton} signup={signup} />
    </section>
  );
}
